import { Theme } from '@mui/material/styles'
import { focusRing } from './Focus'

// ----------------------------------------------------------------------

export default function Link(theme: Theme) {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
      styleOverrides: {
        root: {
          borderRadius: 3,
          '&:focus-visible': focusRing(theme),
        },
      },
    },
  }
}
